import { ValidFormData } from 'hooks/useTypedForm';
import { convertDate } from 'utils/dates';
import * as Yup from 'yup';

export const formConstants = {
  targetShipDate: {
    label: 'New Scheduled Ship Date',
    id: 'targetShipDate' as const,
  },
  shipPartial: {
    label: 'Ship Partial',
    id: 'shipPartial' as const,
  },
};

export const estimatedShipDateValidationSchema = Yup.object({
  [formConstants.targetShipDate.id]: Yup.date()
    .nullable()
    .transform((value, originalValue) => {
      // Handle empty string or null values
      if (!originalValue) return null;
      // If it's already a Date object, return it
      if (originalValue instanceof Date) return originalValue;
      // Otherwise try to convert from string to Date
      try {
        return convertDate(originalValue);
      } catch (e) {
        return null;
      }
    }),
  [formConstants.shipPartial.id]: Yup.boolean().required(),
});

export type EstimatedShipDateValidFormData = ValidFormData<
  typeof estimatedShipDateValidationSchema
>;
